export enum EPackageType {
  ENET = "E-Net Access",
  VBIL = "VoB BIL",
  BROADBAND = "Broadband",
}
